type PowerRCIconProps = {
  color?: string;
  size?: string;
}

export const PowerRCIcon = ({ color, size }: PowerRCIconProps): JSX.Element => (
  <svg width={size ?? '24'} height={size ?? '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.999 4.00146V12.0003M16.9457 7.71292C17.9244 8.71981 18.5909 10.0025 18.8608 11.3989C19.1307 12.7953 18.9919 14.2427 18.4621 15.558C17.9322 16.8733 17.035 17.9975 15.8839 18.7884C14.7328 19.5793 13.3795 20.0015 11.9951 20.0015C10.6107 20.0015 9.25746 19.5793 8.10636 18.7884C6.95527 17.9975 6.05806 16.8733 5.52818 15.558C4.9983 14.2427 4.85954 12.7953 5.12946 11.3989C5.39937 10.0025 6.06583 8.71981 7.04456 7.71292" stroke={color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
